import { render, staticRenderFns } from "./WarehouseTransferCommands.vue?vue&type=template&id=2a828e34&"
import script from "./WarehouseTransferCommands.vue?vue&type=script&lang=ts&"
export * from "./WarehouseTransferCommands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports